module.exports = __webpack_public_path__ + "static/media/ICT-1.72409f05.jpg";